import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import useUser from '../../hooks/use-user';
import Skeleton from '../../components/Templates/skeleton';
import NotFound from '../../components/NotFound/NotFound';
import trackEvent from '../../utils/event-helper';
import TemplatesLayout from '../../layouts/TemplatesLayout/TemplatesLayout';
import contents, { moreEnginesFilters } from '../../consts/verticalContents';
import {
  useStateValue,
} from '../../state/stateProvider';
import { getVerticalRoute } from '../../utils/navigation-utils';
import usePublisher from '../../hooks/use-publisher';

const Vertical = () => {
  const [{ hasHeaderNotification, isIframe }] = useStateValue();
  const router = useRouter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { vertical, origin }: any = router.query;
  const { user } = useUser();
  const [content, setContent] = useState(null);
  const { publisher } = usePublisher();

  const handleVertical = () => {
    const verticalRoute = getVerticalRoute(vertical, true);
    if (verticalRoute && verticalRoute !== vertical) {
      router.replace({
        pathname: `/templates/${verticalRoute}`,
      });
    } else {
      const verticalContent = contents[vertical.replace('-', '_')];
      if (content?.filters?.moreFilters) {
        verticalContent.filters!.moreFilters = content.filters.moreFilters;
      }
      setContent(verticalContent);
    }
  };

  const filterEngines = () => {
    if (publisher?.engines?.length) {
      content.filters.moreFilters = moreEnginesFilters.filter(
        (el) => publisher.engines.includes(el.name),
      );
    }
    content.filters.moreFilters = content?.filters?.moreFilters.map((el) => el.title);
  };

  useEffect(() => {
    trackEvent('template_page_loaded', {
      tabName: origin,
      channelVertical: vertical,
    });
  }, []);

  useEffect(() => {
    if (vertical) {
      handleVertical();
    }
  }, [vertical]);

  useEffect(() => {
    if (content) {
      filterEngines();
    }
  }, [publisher]);

  if (!content) {
    return isIframe ? null : <NotFound />;
  }

  return (
    <Skeleton
      content={content}
      user={user}
      hasHeaderNotification={hasHeaderNotification} />
  );
};

Vertical.layout = TemplatesLayout;
export default Vertical;
